const UNAUTHORIZED = 401;
const SESSION_STATUS = {
    LOADING: 'LOADING', UNSET: 'UNSET', ESTABLISHED: 'ESTABLISHED'
};

const API_BASE_ROUTE = process.env.REACT_APP_API_BASE_ROUTE;
// const API_BASE_ROUTE = 'http://localhost:8080'
// const API_BASE_ROUTE = 'https://test.exceed.ai';
// const API_BASE_ROUTE = 'https://prod.exceed.ai'
const BASE_ROUTE = `${API_BASE_ROUTE}/api`;
const BASE_ROOT_ROUTE = `${API_BASE_ROUTE}`;

export const callApi = (route, data, options, rootRoute, onErr) => {
    let url;

    if (rootRoute) {
        url = new URL(`${BASE_ROOT_ROUTE}${route}`)
    } else {
        url = new URL(`${BASE_ROUTE}${route}`)
    }
    const optionsToSend = Object.assign({}, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        useQueryParameters: false,
        credentials: 'include'
    }, options);

    if (data) {
        switch (optionsToSend['method']) {
            case 'get': {
                Object.keys(data).forEach(key => url.searchParams.append(key, data[key]));
                break
            }
            case 'post': {
            }
            // eslint-disable-next-line
            case 'put':
            case 'delete': {
                if (optionsToSend['useQueryParameters'])
                    Object.keys(data).forEach(key => url.searchParams.append(key, data[key]));
                else
                    optionsToSend['body'] = JSON.stringify(data);
                break
            }
            default:
                throw new Error(`Unexpected error: Got data to send while the request method is '${optionsToSend['method']}'`)
        }
    }

    return fetch(url, optionsToSend)
        .then(response => {
            if (response.ok) {
                const contentType = response.headers.get('content-type');
                if (contentType?.indexOf('application/json') !== -1) {
                    return response.json();
                } else {
                    console.error("got wrong response type " + contentType);
                    return {}
                }
            } else {
                if (response.status === UNAUTHORIZED) {
                    this.setSessionStatus(SESSION_STATUS.UNSET)
                }
                response.json().then(json => {
                    if (onErr) {
                        onErr(json.errorMessage);
                    } else {
                        if (response.status !== UNAUTHORIZED) {
                            // this.setGlobalAlert(true);
                        }
                    }
                });

                return new Promise((resolve, reject) => reject());
            }
        }, error => {
            if (onErr) {
                onErr();
            } else {
                // this.setGlobalAlert(true);
            }

            return new Promise((resolve, reject) => reject());
        })
}